import { render } from "./AllNormativeDocumentTypes.vue?vue&type=template&id=5b3cf778"
import script from "./AllNormativeDocumentTypes.vue?vue&type=script&lang=js"
export * from "./AllNormativeDocumentTypes.vue?vue&type=script&lang=js"

import "./AllNormativeDocumentTypes.vue?vue&type=style&index=0&id=5b3cf778&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__